import { useNavigate } from "react-router-dom";
import React, { useEffect, useState }  from "react";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';


export default function AddExpensehead()
{
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const navigate = useNavigate();
    const [settings, setSettings] = useState([]);
    var expenseheadid =settings.length > 0 ? settings[0].ExpenseHeadID + 1 : 1;

    useEffect(()=>
    {
            fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
            .then(res=>res.json())
            .then((data)=>{setSettings(data)});
            
    },[])

    console.log(expenseheadid);

    function enterheadname()
    {
       var head = document.getElementById('ehead').value;
       
       const expensehead = new FormData();
       expensehead.append("expenseheadid", expenseheadid);
       expensehead.append("expenseheadname",head);

        fetch(API_URL+"api/Expense/CreateExpenseHead",{method:"POST",body:expensehead})
        .then(res=>res.json())
        .then(()=>{});

        fetch(API_URL+"api/Expense/IncrementExpenseHeadID?id="+expenseheadid,{method:"PUT",body:null})
        .then(res=>res.json())
        .then(()=>{});

        
        showOKdialog();
    }

    function showOKdialog()
    {
        const dialog = document.getElementById('myDialog');
         dialog.showModal();
    }

    return(
        <>
        <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
            paddingTop:"10px", top :"0px", position:"relative", fontFamily:"sans-serif",
            fontSize:"18px",marginBottom:"2%"}}> 
            Add ExpenseHead
            <Navbar/>
        </div> 
            
        <div style={{marginTop:"40px",width:"100%"}}>
        <label for = "eheadid" style ={{marginLeft:"1%",marginTop:"20px"}}>Expense Head ID</label><br/>
        <input id = "eheadid"  style = {{height:"30px",width:"96%",marginLeft:"1%",marginBottom:"20px"}} Value={expenseheadid} readOnly></input><br/>
        <label for = "ehead" style ={{marginLeft:"1%",marginTop:"20px"}}>Expense Head</label><br/>
        <input id = "ehead" style = {{height:"30px",width:"96%",marginLeft:"1%",marginBottom:"20px"}}  autoFocus></input><br/>
        <button className="actionbuttons" type="submit" onClick={()=>{enterheadname()}}>Add</button>
        <button className="actionbuttons" style ={{backgroundColor:"red"}} type="submit" onClick={()=>{navigate('/expenses')}}>Cancel</button>
        </div>

        <dialog id="myDialog" className="okdialog"> <p> New Expense Head Created </p>
            <button className="okdialogbutton" onClick={()=>{navigate('/expenses')}}>OK</button>
        </dialog>
        </>
    )
}